import { gql } from '@apollo/client';

export const getBusinessPartnerDetailsInfo = gql`
  query getBusinessPartnerDetailsInfo($id: String!) {
    salesforce {
      getBusinessPartnerDetails(id: $id) {
        auxiliaryAccount
        code
        createdBy
        createdOn
        fullName
        hasAccessToAllInsured
        id
        isCompany
        isLocal
        isRegistered
        maxCreditLimitAllowed
        maxCreditLimitAllowedCurrency
        modifiedBy
        modifiedOn
        personId
        registerationExpiryDate
        registerationNumber
        relatedCompany
        status
        taxAuxiliaryAccount
        type

        company {
          code
          createdOn
          externalCode
          id
          modifiedOn
          title
        }

        person {
          id
          type
          title
          firstName
          middleName
          lastName
          fullName
          email
          code
          dateOfBirth
          isTaxable
          phoneDetails {
            phoneNumber
            phoneType
          }
          addresses {
            addressType
            createdBy
            createdOn
            id
            isPrimary
            modifiedBy
            modifiedOn
            personId
            status
            address {
              addressDetails
              addressDetailsArabic
              building
              city
              country
              street
              zone
            }
            country {
              code
              createdOn
              id
              modifiedOn
              title
            }
            zone {
              code
              createdOn
              id
              modifiedOn
              title
            }
          }
        }

        currency {
          id
          code
          title
          titleAr
          symbol
        }
      }
    }
  }
`;
export const getEntityAuditTrailsQuery = gql`
  query getEntityAuditTrails($id: String!) {
    core {
      getEntityAuditTrails(id: $id) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;
